import { render, staticRenderFns } from "./ProfitLossReport.vue?vue&type=template&id=b7d340ca&"
import script from "./ProfitLossReport.vue?vue&type=script&lang=ts&"
export * from "./ProfitLossReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7d340ca')) {
      api.createRecord('b7d340ca', component.options)
    } else {
      api.reload('b7d340ca', component.options)
    }
    module.hot.accept("./ProfitLossReport.vue?vue&type=template&id=b7d340ca&", function () {
      api.rerender('b7d340ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounting/reports/ProfitLossReport.vue"
export default component.exports